import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/one-vigilance/farmacovigilancia-formacion-combinada-certificada")({
  head: () => buildRouteHead("/es/servicios/one-vigilance/farmacovigilancia-formacion-combinada-certificada", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/servicios/farmacovigilancia/farmacovigilancia-formacion-combinada-certificada", replace: true });
  },
});
